import Drawer from "../../../../components/Drawer";
import Spinner from "react-bootstrap/Spinner";
import React, { useState } from "react";
import { MenuItem, TextField } from "@material-ui/core";
import Excel from "exceljs";
import api from "../../../../config/api";
import swal from "sweetalert";
import default_product_list from "../../../../assets/upload/default_product_list.xlsx";

const ImportXlsxDrawer = ({
  openImportDrawer,
  setImportDrawer,
  subCategories,
  getAllProduct,
  getProductByEstablishment,
  getProductVariations,
  getTypes,
}) => {
  const [categorySelected, setCategorySelected] = useState("");
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    const category = JSON.parse(categorySelected);

    reader.onload = async (e) => {
      const workbook = new Excel.Workbook();
      await workbook.xlsx.load(e.target.result).then(async () => {
        const sheet = workbook.getWorksheet(1);
        const headerRow = sheet.getRow(1);
        const headers = headerRow.values;
        const products = [];
        for (let i = 2; i <= sheet.rowCount; i++) {
          const productsRow = sheet.getRow(i);
          const product = {
            category: category._id,
            establishment: category.establishment,
            type: category.type,
          };
          headers.forEach((header, index) => {
            product[header] = productsRow.values[index];
          });
          products.push(product);
        }
        setData(products);
        for (let i = 0; i < products.length; i++) {
          const productComplete = products[i];
          const response = await api
            .post(`/products-excel`, productComplete)
            .then((resp) => {
              if (resp.data.success) {
                swal("Sucesso!", "Produtos cadastrados com sucesso!", "success");
                getAllProduct();
                getProductByEstablishment();
                getProductVariations();
                getTypes();
                clear();
              } else {
                swal("Error!", "Revise as informações enviadas!", "error");
                clear();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    };
    reader.readAsArrayBuffer(file);
  };

  const verifyError = () => {
    if (!categorySelected) {
      setError(true);
    } else {
      setError(false);
    }
  };

  const clear = () => {
    setCategorySelected("");
    setError(false);
    setData([]);
    setImportDrawer(false);
  };

  return (
    <Drawer show={openImportDrawer} onClose={() => clear()} className="h-100">
      <form style={{ maxHeight: "100%" }} className="h-100">
        <div className="d-flex flex-column h-100">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-3 d-block mb-5">Importar Planilha </span>
          <TextField
            name="productCategory"
            variant="outlined"
            value={categorySelected}
            onChange={(e) => setCategorySelected(e.target.value)}
            error={error}
            required
            select
            label="Selecione uma categoria para os produtos"
            className="col-lg-12 fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          >
            {subCategories.map((category) => (
              <MenuItem key={category._id} value={JSON.stringify(category)}>
                {category.name}
              </MenuItem>
            ))}
          </TextField>

          <div className={`col-12 justify-content-end d-flex mb-3`}>
            <div className={` col-12  d-flex justify-content-end align-items-center py-2 `}>
              <a className="me-auto c-pointer" href={default_product_list} download>
                Planilha de exemplo
              </a>
              <label
                onClick={() => verifyError()}
                className={` btn btn-white button-white-primary fz-14 px-3 py-2  d-flex justify-content-center align-items-center ff-univanova-regular`}
              >
                Importar planilha
                <input disabled={!categorySelected} type="file" className="d-none" onInput={(e) => handleFile(e)} />
              </label>
            </div>
          </div>
        </div>
      </form>
    </Drawer>
  );
};

export default ImportXlsxDrawer;
